import { render, staticRenderFns } from "./DataComplianceManager.vue?vue&type=template&id=b163a76e&scoped=true"
import script from "./DataComplianceManager.vue?vue&type=script&lang=js"
export * from "./DataComplianceManager.vue?vue&type=script&lang=js"
import style0 from "./DataComplianceManager.vue?vue&type=style&index=0&id=b163a76e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b163a76e",
  null
  
)

export default component.exports